import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'companies',
  inputShow: gql`
    query companies($input: CompanyQueryInput) {
      companies(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Companies',
    group: 'Facilities',
    order: 1,
  },
};
